// This file was automatically generated from print.letter.attachments.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.letter.attachments');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.attachments.tableOfContents = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.attachments && opt_data.attachments.length) {
    output.append('<p class="mt20 emphasis pb5">Interactive Patient Chart Contents:</p>');
    if (opt_data.withArchive) {
      el8.template.print.letter.attachments._chartExportToc({groupedAttachments: _.sortBy(_.pairs(_.groupBy(opt_data.attachments, 'entityDescription')), function(p) { return p[0]; })}, output);
    } else {
      output.append('<ul class="list normalText ml10">');
      var aList14706 = opt_data.attachments;
      var aListLen14706 = aList14706.length;
      for (var aIndex14706 = 0; aIndex14706 < aListLen14706; aIndex14706++) {
        var aData14706 = aList14706[aIndex14706];
        output.append('<li class="bulletEllipsis">');
        el8.template.ptdata.letters.attachments.savedAttachmentSummary(soy.$$augmentData(aData14706, {noAttachmentLinks: true}), output);
        output.append('</li>');
      }
      output.append('</ul>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.attachments._chartExportToc = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="list normalText ml10">');
  var groupList14715 = opt_data.groupedAttachments;
  var groupListLen14715 = groupList14715.length;
  for (var groupIndex14715 = 0; groupIndex14715 < groupListLen14715; groupIndex14715++) {
    var groupData14715 = groupList14715[groupIndex14715];
    output.append('<li class="bulletEllipsis">', soy.$$escapeHtml(groupData14715[0]), ': ', soy.$$escapeHtml(groupData14715[1].length), '</li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};
